stimulusApp.register(
  "cruise-months",
  class extends Stimulus.Controller {
    static targets = ["year", "prev", "next", "slide", "viewport"]

    #index = 0

    connect() {
      const currentIndex = this.slideTargets.findIndex(
        (slide) => slide.dataset.current === "true",
      )

      if (currentIndex > 0) {
        this.#show(currentIndex, "auto")
      } else {
        this.#refreshNav()
      }
    }

    prev(event) {
      event.preventDefault()
      this.#show(this.#index - 1)
    }

    next(event) {
      event.preventDefault()
      this.#show(this.#index + 1)
    }

    #show(index, behavior) {
      if (index < 0 || index >= this.slideTargets.length) return

      this.#index = index
      const slide = this.slideTargets[index]
      const reduceMotion = window.matchMedia?.(
        "(prefers-reduced-motion: reduce)",
      )?.matches
      const delta =
        slide.getBoundingClientRect().left -
        this.viewportTarget.getBoundingClientRect().left

      this.viewportTarget.scrollBy({
        left: delta,
        behavior: behavior || (reduceMotion ? "auto" : "smooth"),
      })
      this.slideTargets.forEach((candidate, candidateIndex) => {
        candidate.inert = candidateIndex !== index
      })
      this.yearTarget.textContent = slide.dataset.year
      this.#refreshNav()
    }

    #refreshNav() {
      const states = [
        [this.prevTarget, this.#index === 0],
        [this.nextTarget, this.#index === this.slideTargets.length - 1],
      ]

      states.forEach(([button, disabled]) => {
        button.disabled = disabled
      })
    }
  },
)
